// import { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import './Navigation.css';

// const Navigation = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
//       <div className="nav-container">
//         <Link to="/" className="logo">
//           <div className="logo-text">
//             <span className="logo-main">NexaAI</span>
//             <span className="logo-sub">Studio</span>
//           </div>
//         </Link>

//         <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
         
//           <Link 
//             to="/contact" 
//             className={location.pathname === '/contact' ? 'active' : ''}
//             onClick={() => setMenuOpen(false)}
//           >
//             Contact
//           </Link>
//         </div>

//         <button 
//           className="menu-toggle"
//           onClick={() => setMenuOpen(!menuOpen)}
//           aria-label="Toggle menu"
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </button>
//       </div>
//     </nav>
//   );
// };

// export default Navigation;


import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import NexaLogoIcon from './NexaLogoIcon';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/tools', label: 'Tools Hub', isBadge: true },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <>
      {/* Navigation Bar */}
      <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          {/* Logo */}
          <Link to="/" className="logo">
            <NexaLogoIcon size={40} />
            <div className="logo-text">
              <span className="logo-main">Nexa<span className="orange-text">AI</span></span>
              <span className="logo-sub">STUDIO</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="nav-links desktop-only">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                <span>{link.label}</span>
                {link.isBadge && <span className="nav-badge">Hub</span>}
                <span className="nav-link-underline"></span>
              </Link>
            ))}
          </div>

          {/* Let's Talk Button - Desktop */}
          <div className="desktop-only">
            <Link to="/contact" className="cta-button">
              <span>Let's Talk</span>
              <ArrowRight className="cta-icon" />
              <div className="cta-gradient"></div>
              <div className="cta-shine"></div>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="menu-toggle"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <div
        className={`menu-overlay ${menuOpen ? 'active' : ''}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* Mobile Side Panel */}
      <div className={`side-panel ${menuOpen ? 'active' : ''}`}>
        <div className="side-panel-container">
          {/* Panel Header */}
          <div className="side-panel-header">
            <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
              <NexaLogoIcon size={36} />
              <div className="logo-text">
                <span className="logo-main">Nexa<span className="orange-text">AI</span></span>
                <span className="logo-sub">STUDIO</span>
              </div>
            </Link>
            <button
              onClick={() => setMenuOpen(false)}
              className="close-button"
              aria-label="Close menu"
            >
              <X size={24} />
            </button>
          </div>

          {/* Panel Links */}
          <div className="side-panel-content">
            <div className="side-panel-links">
              {navLinks.map((link, index) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMenuOpen(false)}
                  className={`side-link ${location.pathname === link.path ? 'active' : ''}`}
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <span>{link.label}</span>
                  <ArrowRight className="side-link-icon" />
                </Link>
              ))}
            </div>

            {/* Let's Talk Button - Mobile */}
            <div className="side-panel-cta">
              <Link
                to="/contact"
                onClick={() => setMenuOpen(false)}
                className="cta-button mobile"
              >
                <span>Let's Talk</span>
                <ArrowRight className="cta-icon" />
                <div className="cta-gradient"></div>
              </Link>
            </div>

            {/* Contact Info */}
            <div className="side-panel-footer">
              <div className="contact-info">
                <a href="mailto:hello@nexaai.com" className="contact-item">
                  <span>📧</span>
                  <span>hello@nexaai.com</span>
                </a>
                <a href="tel:+1234567890" className="contact-item">
                  <span>📞</span>
                  <span>+1 (234) 567-890</span>
                </a>
              </div>

              {/* Social Links */}
              <div className="social-links">
                <a href="#" className="social-link">Twitter</a>
                <span className="social-divider">•</span>
                <a href="#" className="social-link">LinkedIn</a>
                <span className="social-divider">•</span>
                <a href="#" className="social-link">GitHub</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navigation;